<template>
<b-container fluid>
  <b-row>
    <b-col md="4">
      <b-form-group label="Filter events" label-cols="3">
        <b-input-group>
          <b-form-select v-model="filter" :options="filterEventsTypes">
            <template slot="first">
              <option selected :value="null">-- ALL --</option>
            </template>
          </b-form-select>
        </b-input-group>
      </b-form-group>
    </b-col>
  </b-row>

  <b-table :busy.sync="isBusy" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :fields="fields" :items="this.events">
    <template v-slot:cell(details)="row">
      <EventDetails v-bind:event_details="row.item.event_data" />
    </template>
  </b-table>
</b-container>
</template>

<script>
import { deviceService } from "@/_services";
import datetimeFormatter from '@/core/datetimeFormatterHelper';
import EventDetails from './EventDetails';
export default {
  name: 'EventsTable',
  components: {
    EventDetails,
  },
  data() {
    return {
      sortBy: 'event_time',
      sortDesc: true,
      isBusy: false,
      filter: null,
      fields: [{
          key: 'event_type',
          label: 'EVENT TYPE',
          sortable: true
        },
        {
          key: 'event_time',
          label: 'EVENT TIME',
          formatter: datetimeFormatter,
          sortable: true
        },
        {
          key: 'received_time',
          label: 'RECEIVED TIME',
          formatter: datetimeFormatter,
          sortable: true
        },
        {
          key: 'details',
          label: 'DETAILS'
        }
      ],
      events: []
    }
  },
  computed: {
    filterEventsTypes() {
      // Create an options list from our fields
      return Array.from(new Set(this.events.map(ev => ev.event_type)))
    }
  },
  mounted() {
    deviceService.findEventsForDevice(this.$route.params.serial)
      .then(response => {
        this.events = response.data.events;
      })
        .catch(() => {
        this.error('Error getting Device Events');
      });
  }
}
</script>
<style src="./EventsTable.scss" lang="scss" scoped/>
